// Nutrient catalog for the Catalog Manager nutrient editor (type-to-search add).
//
// TODO(nutrient-catalog): This is a hand-mirrored copy of the canonical map at
//   b2b-infrastructure: api/common/food_ingest/advisor_nutrients.json
// It is duplicated here because that file lives in a different repo and the
// accounts tsconfig does not enable JSON module imports. There is no nutrient
// catalog in the platform grounding-search scripts to point at yet. When we
// have a shared source of truth (e.g. a products API endpoint that serves the
// nutrient list, or a generated/synced data file), replace NUTRIENT_CATALOG
// below with that source so we don't drift. Until then, keep this list in sync
// with advisor_nutrients.json when nutrients are added/changed.

export interface NutrientDef {
  /** Passio nutrient id (number, as stored in advisor_nutrients.json). */
  id: number;
  name: string;
  unit: string;
  shortName?: string;
}

export const NUTRIENT_CATALOG: NutrientDef[] = [
  { id: 1603211196544, name: "Protein", unit: "G", shortName: "protein" },
  { id: 1603211196545, name: "Total lipid (fat)", unit: "G", shortName: "fat" },
  {
    id: 1603211196546,
    name: "Carbohydrate, by difference",
    unit: "G",
    shortName: "carbs",
  },
  { id: 1603211196548, name: "Energy", unit: "KCAL", shortName: "calories" },
  { id: 1603211196549, name: "Starch", unit: "G", shortName: "starch" },
  { id: 1603211196550, name: "Sucrose", unit: "G", shortName: "sucrose" },
  {
    id: 1603211196551,
    name: "Glucose (dextrose)",
    unit: "G",
    shortName: "glucose",
  },
  { id: 1603211196552, name: "Fructose", unit: "G", shortName: "fructose" },
  { id: 1603211196553, name: "Lactose", unit: "G", shortName: "lactose" },
  { id: 1603211196554, name: "Maltose", unit: "G", shortName: "maltose" },
  {
    id: 1603211196555,
    name: "Alcohol, ethyl",
    unit: "G",
    shortName: "alcohol",
  },
  { id: 1603211196564, name: "Caffeine", unit: "MG", shortName: "caffeine" },
  {
    id: 1603211196571,
    name: "Fiber, total dietary",
    unit: "G",
    shortName: "fiber",
  },
  {
    id: 1603211196573,
    name: "Fiber, soluble",
    unit: "G",
    shortName: "solubleFiber",
  },
  {
    id: 1603211196574,
    name: "Fiber, insoluble",
    unit: "G",
    shortName: "insolubleFiber",
  },
  {
    id: 1603211196576,
    name: "Total sugar alcohols",
    unit: "G",
    shortName: "sugarAlcohol",
  },
  { id: 1603211196577, name: "Calcium, Ca", unit: "MG", shortName: "calcium" },
  { id: 1603211196579, name: "Iron, Fe", unit: "MG", shortName: "iron" },
  {
    id: 1603211196580,
    name: "Magnesium, Mg",
    unit: "MG",
    shortName: "magnesium",
  },
  {
    id: 1603211196581,
    name: "Phosphorus, P",
    unit: "MG",
    shortName: "phosphorus",
  },
  {
    id: 1603211196582,
    name: "Potassium, K",
    unit: "MG",
    shortName: "potassium",
  },
  { id: 1603211196583, name: "Sodium, Na", unit: "MG", shortName: "sodium" },
  { id: 1603211196585, name: "Zinc, Zn", unit: "MG", shortName: "zinc" },
  {
    id: 1603211196586,
    name: "Chromium, Cr",
    unit: "UG",
    shortName: "chromium",
  },
  { id: 1603211196590, name: "Iodine, I", unit: "UG", shortName: "iodine" },
  {
    id: 1603211196591,
    name: "Manganese, Mn",
    unit: "MG",
    shortName: "manganese",
  },
  {
    id: 1603211196593,
    name: "Selenium, Se",
    unit: "UG",
    shortName: "selenium",
  },
  {
    id: 1603211196594,
    name: "Vitamin A, IU",
    unit: "IU",
    shortName: "vitaminA",
  },
  { id: 1603211196596, name: "Vitamin A, RAE", unit: "UG" },
  {
    id: 1603211196599,
    name: "Vitamin E (alpha-tocopherol)",
    unit: "MG",
    shortName: "vitaminE",
  },
  {
    id: 1603211196600,
    name: "Vitamin D (D2 + D3), International Units",
    unit: "IU",
  },
  {
    id: 1603211196601,
    name: "Vitamin D2 (ergocalciferol)",
    unit: "UG",
    shortName: "vitaminD2",
  },
  {
    id: 1603211196602,
    name: "Vitamin D3 (cholecalciferol)",
    unit: "UG",
    shortName: "vitaminD3",
  },
  {
    id: 1603211196604,
    name: "Vitamin D (D2 + D3)",
    unit: "UG",
    shortName: "vitaminD",
  },
  { id: 1603211196609, name: "Lutein", unit: "UG", shortName: "lutein" },
  { id: 1603211196610, name: "Lycopene", unit: "UG", shortName: "lycopene" },
  { id: 1603211196622, name: "Vitamin E", unit: "MG_ATE" },
  {
    id: 1603211196626,
    name: "Vitamin C, total ascorbic acid",
    unit: "MG",
    shortName: "vitaminC",
  },
  { id: 1603211196627, name: "Thiamin", unit: "MG", shortName: "vitaminB1" },
  { id: 1603211196628, name: "Riboflavin", unit: "MG", shortName: "vitaminB2" },
  { id: 1603211196629, name: "Niacin", unit: "MG", shortName: "vitaminB3" },
  {
    id: 1603211196630,
    name: "Pantothenic acid",
    unit: "MG",
    shortName: "vitaminB5",
  },
  {
    id: 1603211196631,
    name: "Vitamin B-6",
    unit: "MG",
    shortName: "vitaminB6",
  },
  { id: 1603211196632, name: "Biotin", unit: "UG", shortName: "biotin" },
  { id: 1603211196633, name: "Folate, total", unit: "UG", shortName: "folate" },
  {
    id: 1603211196634,
    name: "Vitamin B-12",
    unit: "UG",
    shortName: "vitaminB12",
  },
  {
    id: 1603211196635,
    name: "Choline, total",
    unit: "MG",
    shortName: "choline",
  },
  { id: 1603211196637, name: "Vitamin K (Menaquinone-4)", unit: "UG" },
  { id: 1603211196638, name: "Vitamin K (Dihydrophylloquinone)", unit: "UG" },
  { id: 1603211196639, name: "Vitamin K (phylloquinone)", unit: "UG" },
  { id: 1603211196640, name: "Folic acid", unit: "UG", shortName: "folicAcid" },
  { id: 1603211196643, name: "Folate, DFE", unit: "UG" },
  { id: 1603211196652, name: "Tryptophan", unit: "G" },
  { id: 1603211196653, name: "Threonine", unit: "G" },
  { id: 1603211196654, name: "Isoleucine", unit: "G" },
  { id: 1603211196655, name: "Leucine", unit: "G" },
  { id: 1603211196656, name: "Lysine", unit: "G" },
  { id: 1603211196657, name: "Methionine", unit: "G" },
  { id: 1603211196658, name: "Cystine", unit: "G" },
  { id: 1603211196659, name: "Phenylalanine", unit: "G" },
  { id: 1603211196660, name: "Tyrosine", unit: "G" },
  { id: 1603211196661, name: "Valine", unit: "G" },
  { id: 1603211196662, name: "Arginine", unit: "G" },
  { id: 1603211196663, name: "Histidine", unit: "G" },
  { id: 1603211196664, name: "Alanine", unit: "G" },
  { id: 1603211196665, name: "Aspartic acid", unit: "G" },
  { id: 1603211196666, name: "Glutamic acid", unit: "G" },
  { id: 1603211196667, name: "Glycine", unit: "G" },
  { id: 1603211196668, name: "Proline", unit: "G" },
  { id: 1603211196669, name: "Serine", unit: "G" },
  { id: 1603211196670, name: "Hydroxyproline", unit: "G" },
  { id: 1603211196671, name: "Cysteine", unit: "G" },
  { id: 1603211196672, name: "Glutamine", unit: "G" },
  { id: 1603211196673, name: "Taurine", unit: "G" },
  {
    id: 1603211196674,
    name: "Sugars, added",
    unit: "G",
    shortName: "sugarAdded",
  },
  {
    id: 1603211196675,
    name: "Vitamin E, added",
    unit: "MG",
    shortName: "vitaminEAdded",
  },
  {
    id: 1603211196676,
    name: "Vitamin B-12, added",
    unit: "UG",
    shortName: "vitaminB12Added",
  },
  {
    id: 1603211196677,
    name: "Cholesterol",
    unit: "MG",
    shortName: "cholesterol",
  },
  {
    id: 1603211196678,
    name: "Fatty acids, total trans",
    unit: "G",
    shortName: "transFat",
  },
  {
    id: 1603211196679,
    name: "Fatty acids, total saturated",
    unit: "G",
    shortName: "satFat",
  },
  { id: 1603211196693, name: "22:6 n-3 (DHA)", unit: "G", shortName: "dha" },
  { id: 1603211196699, name: "20:5 n-3 (EPA)", unit: "G", shortName: "epa" },
  { id: 1603211196701, name: "22:5 n-3 (DPA)", unit: "G", shortName: "dpa" },
  {
    id: 1603211196709,
    name: "Fatty acids, total monounsaturated",
    unit: "G",
    shortName: "monounsaturatedFat",
  },
  {
    id: 1603211196710,
    name: "Fatty acids, total polyunsaturated",
    unit: "G",
    shortName: "polyunsaturatedFat",
  },
  { id: 1603211196741, name: "Inulin", unit: "G", shortName: "inulin" },
  {
    id: 1603211196751,
    name: "Sugars, total including NLEA",
    unit: "G",
    shortName: "sugarTotal",
  },
  { id: 1628606728129, name: "Mannitol", unit: "G" },
  { id: 1628606728155, name: "Oligosaccharides", unit: "G" },
  { id: 1628606728190, name: "Vitamin A, RE", unit: "MCG_RE" },
  { id: 1628606728199, name: "Salt, NaCl", unit: "MG", shortName: "salt" },
  { id: 1628606728248, name: "Flavanones, total", unit: "MG" },
  { id: 1628606728255, name: "Flavones, total", unit: "MG" },
  { id: 1628606728261, name: "Mannose", unit: "G" },
  { id: 1628606728298, name: "Isoflavones", unit: "MG" },
  { id: 1628606728305, name: "Flavonols, total", unit: "MG" },
];

const byId = new Map<number, NutrientDef>(
  NUTRIENT_CATALOG.map((n) => [n.id, n])
);

export const nutrientDefById = (id: number | string): NutrientDef | undefined =>
  byId.get(typeof id === "string" ? Number(id) : id);

/** Case-insensitive search over name + shortName. Returns up to `limit` hits. */
export const searchNutrients = (query: string, limit = 12): NutrientDef[] => {
  const q = query.trim().toLowerCase();
  if (!q) return NUTRIENT_CATALOG.slice(0, limit);
  const starts: NutrientDef[] = [];
  const contains: NutrientDef[] = [];
  for (const n of NUTRIENT_CATALOG) {
    const name = n.name.toLowerCase();
    const short = (n.shortName || "").toLowerCase();
    if (name.startsWith(q) || short.startsWith(q)) starts.push(n);
    else if (name.includes(q) || short.includes(q)) contains.push(n);
  }
  return [...starts, ...contains].slice(0, limit);
};
